import ConfirmIrreversible from '../components/ConfirmIrreversible';
import styles from '../SCSS/DeleteClassroomModal.module.scss';

interface Props {
  classroomName: string;
  numOfStudents: string;
  show: boolean;
  hideModal: () => void;
  confirmTestString: string;
  archiveClassroom: () => void;
}

const ArchiveClassroomModal = (props: Props): JSX.Element => {
  const { classroomName, numOfStudents, show, hideModal, confirmTestString, archiveClassroom } = props;

  const withNumberOfStudents = `with ${numOfStudents} students?`;
  const warningMessage = (
    <span className={styles.warningMessage}>
      Are you sure you want to archive your classroom{' '}
      <strong className={styles.bold}>&ldquo;{classroomName || 'Main Class'}&rdquo;</strong>{' '}
      {parseInt(numOfStudents) > 0 ? withNumberOfStudents : '?'}
      <br />
      You can always unarchive your classroom later.
    </span>
  );

  const instructions = 'To confirm, please type out the name of your classroom below.';

  return (
    <>
      {show && (
        <ConfirmIrreversible
          hideModal={hideModal}
          title='Archive Classroom'
          confirmTestString={confirmTestString}
          performIrreversibleAction={archiveClassroom}
          instructions={instructions}
          warningMessage={warningMessage}
          alert={false}
        />
      )}
    </>
  );
};

export default ArchiveClassroomModal;
